import VisaImg from './ic-visa.svg';
import MasterCardImg from './ic-master.svg';
import AmexImg from './ic-amex.svg';
import DiscoverImg from './ic-disc.svg';
import VisaelectronImg from './ic-visa-ele.svg';
import MaestroImg from './ic-maes.svg';
import UnionpayImg from './ic-union-pay.svg';
import CartesBancairesImg from './ic-cb.svg';
import DinersImg from './ic-diners.svg';
import JCBImg from './ic-jcb.svg';
import Default from './ic-default.svg';
import TipImg from './tip.svg';

export { TipImg };

const Images = {
  VISA: VisaImg,
  MASTER_CARD: MasterCardImg,
  MASTERCARD: MasterCardImg,
  AMEX: AmexImg,
  VISAELECTRON: VisaelectronImg,
  MAESTRO: MaestroImg,
  UNIONPAY: UnionpayImg,
  DISCOVER: [ DiscoverImg, DinersImg ],
  DINERS: [ DiscoverImg, DinersImg ],
  JCB: JCBImg,
  CARTES_BANCAIRES: CartesBancairesImg, // This cardType is just for showing
  DEFAULT: Default, // as a default icon for saved card
};

// 'MASTERCARD', 'DINERS' is from ams, others are from cui,
//  MASTERCARD is equal to MASTER_CARD, and DINERS is equal to  DISCOVER
const cuiSupprtCardTypes = [ 'VISA', 'MASTER_CARD', 'AMEX', 'VISAELECTRON', 'MAESTRO', 'UNIONPAY', 'DISCOVER', 'JCB', 'CARTES_BANCAIRES', 'MASTERCARD', 'DINERS' ];
export const getCardTypes = (type) => {
  return cuiSupprtCardTypes.includes(type) ? type : 'DEFAULT';
};

export default Images;
